import(/* webpackMode: "eager", webpackExports: ["WalletPageClient"] */ "/vercel/path0/app/(lobby)/wallet/WalletPageClient.tsx");
